import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { listDeviceData } from './graphql/queries';

function App() {
    const [deviceData, setDeviceData] = useState([]);

    useEffect(() => {
        const fetchDeviceData = async () => {
            try {
                const response = await API.graphql(graphqlOperation(listDeviceData));
                setDeviceData(response.data.listDeviceData.items);
            } catch (error) {
                console.error('Error fetching device data:', error);
            }
        };

        fetchDeviceData();
    }, []);

    return (
        <div>
            {/* Top Navigation Bar */}
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        Device Data Dashboard
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Container sx={{ marginTop: 4 }}>
                <Typography variant="h5" component="h2" gutterBottom>
                    Device Information
                </Typography>

                {/* Data Table */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Device ID</strong></TableCell>
                                <TableCell><strong>Timestamp</strong></TableCell>
                                <TableCell><strong>System Info</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {deviceData.map((data) => (
                                <TableRow key={data.id}>
                                    <TableCell>{data.DeviceID}</TableCell>
                                    <TableCell>{data.Timestamp}</TableCell>
                                    <TableCell>
                                        {data.SystemInfo ? (
                                            <pre>{JSON.stringify(JSON.parse(data.SystemInfo), null, 2)}</pre>
                                        ) : (
                                            "N/A"
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </div>
    );
}

export default App;
